// NavigationHelper.ts
// This helps with navigation from places where React Router's navigate is not available

let navigationCallback: ((path: string) => void) | null = null

export const setNavigationCallback = (callback: (path: string) => void) => {
  navigationCallback = callback
}

export const navigateToLogin = () => {
  if (navigationCallback) {
    navigationCallback('/login')
  } else {
    // Fallback to window.location.href if no callback is set
    window.location.href = '/login'
  }
}

export const navigateTo = (path: string) => {
  if (navigationCallback) {
    navigationCallback(path)
  } else {
    // Fallback to window.location.href if no callback is set
    window.location.href = path
  }
}
